<template>
<div class="card toast shadow-lg alert alert-warning" role="alert" data-delay="5000">
	<div class="card-body p-0" id="toast-card">
		<i class=" fas fa-exclamation-circle"></i>
		<span>{{data}}</span>
	</div>
</div>
</template>

<style>
.toast {
	position: absolute;
	float: right;
}

#toast-card {
	font-size: 24px;
}
</style>

<script>
import {
	EventManager
} from '@/components/Events/EventManager.js'

import $ from 'jquery'
export default {
	name: 'Toast',
	components: {
		EventManager
	},
	data: function() {
		return {
			data: {}
		}
	},
	created() {
		var that = this;

		EventManager.$on('do-toast', function(data) {
			that.data = data;
			$('.toast').toast('show');
		});
	},
	mounted() {}
}
</script>
